import { SiBigcartel } from "react-icons/si"; 
import { FaServicestack } from "react-icons/fa"; 
import { HiUsers } from "react-icons/hi"; 
import { FcDepartment } from "react-icons/fc"; 
import { SiInstructure } from "react-icons/si"; 
import { BiCategoryAlt } from "react-icons/bi"; 
import React, {useState, useEffect} from 'react'
import './Sidebar.css';
import { FaChevronDown, FaChevronUp, FaFileAlt,  FaBars, FaHospital, FaUsers } from 'react-icons/fa';

function Sidebar({ onMenuSelect }) {
    const [openMenu, setOpenMenu] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [userType, setUserType] = useState(null);


  const toggleMenu = (menu) => {
    if (menu === 'abonnesList' || menu === 'abonnesForm' || menu === 'adminsList' || menu === 'adminsForm' || menu === 'servicesList' || menu === 'servicesForm'|| menu === 'institutionsDash' || menu === 'abonnesDash'|| menu === 'categorieList' || menu === 'categorieForm' || menu === 'partenaireList' || menu === 'partenaireForm' || menu === 'structureList' || menu === 'structureForm' || menu === 'carteList' || menu === 'carteForm' || menu === 'warrantieList' || menu === 'warrantieForm') {
      onMenuSelect(menu);
    } else {
      setOpenMenu(openMenu === menu ? null : menu);
      if (menu === 'abonnesList') {
        onMenuSelect('abonnesList');
      } else if (menu === 'adminsList') {
        onMenuSelect('adminsList');
      } else if (menu === 'servicesList') {
        onMenuSelect('servicesList');
      } else if (menu === 'categorieList') {
        onMenuSelect('categorieList');
      } else if (menu === 'partenaireList') {
        onMenuSelect('partenaireList');
      } else if (menu === 'structureList') {
        onMenuSelect('structureList');
      }
    }
  };

  useEffect(() => {
    // Récupérer le type d'utilisateur depuis le localStorage
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        setUserType(user.type);
    }
}, []);

  return (
    <>
      <div className={`sidebar ${isSidebarOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <h2>ADMINISTRATION</h2>
        </div>

        <div className="sidebar-menu">
          {/* Dashboard */}
          <div className="menu-item">
            <button
              className="menu-button"
              onClick={() => toggleMenu('dashboard')}
            >
              <FaBars className="menu-icon" /> Dashboard
              {openMenu === 'dashboard' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
            </button>
            {openMenu === 'dashboard' && (
              <div className="submenu">
                <a href="/dashboard">Accueil</a>
              </div>
            )}
          </div>

        {/* Dashboard Institutions */}
        {userType === 'institution' && (
        <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('institutionsDash')}
                  >
                    <FaHospital className="menu-icon" /> Opérations
                    {openMenu === 'institutionsDash' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'institutionsDash' && (
                    <div className="submenu">
                      <button className="submenu-link" onClick={() => toggleMenu('institutionsDash')}>Liste des Institutions</button>
                    </div>
                  )}
                </div>
                )}

        {/* Dashboard Abonnés */}
        {userType === 'abonnes' && (
                        <div className="menu-item">
                            <button
                                className="menu-button"
                                onClick={() => toggleMenu('abonnesDash')}
                            >
                                <FaUsers className="menu-icon" /> Mon Historique
                                {openMenu === 'abonnesDash' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                            </button>
                            {openMenu === 'abonnesDash' && (
                                <div className="submenu">
                                    <button className="submenu-link" onClick={() => toggleMenu('abonnesDash')}>Liste des Abonnés</button>
                                </div>
                            )}
                        </div>
                    )}

        {/* Profile */}
          <div className="menu-item">
            <button
              className="menu-button"
              onClick={() => toggleMenu('warrantie')}
            >
              <SiBigcartel className="menu-icon" /> Garanties
              {openMenu === 'warrantie' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
            </button>
            {openMenu === 'warrantie' && (
              <div className="submenu">
                <button className="submenu-link" onClick={() => toggleMenu('warrantieList')}>Voire les garanties</button>
                {/* <button className="submenu-link"  onClick={() => toggleMenu('warrantieForm')}>Ajouter une garantie</button> */}
              </div>
            )}
          </div> 
          

          {/* Profile */}
          {/* <div className="menu-item">
            <button
              className="menu-button"
              onClick={() => toggleMenu('profile')}
            >
              <FaUser className="menu-icon" /> Profile
              {openMenu === 'profile' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
            </button>
            {openMenu === 'profile' && (
              <div className="submenu">
                <a href="/profile">Profil utilisateur</a>
              </div>
            )}
          </div> */}

          {/* Abonnées */}
          {/* {userType === 'admin' && (
            <div className="menu-item">
            <button
              className="menu-button"
              onClick={() => toggleMenu('abonnes')}
            >
              <HiUsers className="menu-icon"/> Abonnées
              {openMenu === 'abonnes' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
            </button>
            {openMenu === 'abonnes' && (
              <div className="submenu">
                <button className="submenu-link"  onClick={() => toggleMenu('abonnesList')}>Liste des abonnés</button>
                <button className="submenu-link"  onClick={() => toggleMenu('abonnesForm')}>Ajouter un abonné</button>
              </div>
            )}
            </div>
          )} */}

          {/* Catégories */}
          {/* {userType === 'admin' && (
            <div className="menu-item">
              <button
                className="menu-button"
                onClick={() => toggleMenu('categories')}
              >
                <BiCategoryAlt className="menu-icon" /> Catégorie
                {openMenu === 'categories' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
              </button>
              {openMenu === 'categories' && (
                <div className="submenu">
                  <button className="submenu-link"  onClick={() => toggleMenu('categorieList')}>Liste des catégories</button>
                  <button className="submenu-link"  onClick={() => toggleMenu('categorieForm')}>Ajouter une catégorie</button>
                </div>
              )}
            </div>
          )} */}

          {/* Parténaires */}
          {/* {userType === 'admin' && (
            <div className="menu-item">
              <button
                className="menu-button"
                onClick={() => toggleMenu('partenaires')}
              >
                <FcDepartment className="menu-icon"/>  Parténaires
                {openMenu === 'partenaires' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
              </button>
              {openMenu === 'partenaires' && (
                <div className="submenu">
                  <button className="submenu-link"  onClick={() => toggleMenu('partenaireList')}>Liste des parténaires</button>
                  <button className="submenu-link"  onClick={() => toggleMenu('partenaireForm')}>Ajouter un partenaire</button>
                </div>
              )}
            </div>
          )} */}

          {/* Structures */}
          {/* {userType === 'admin' && (
            <div className="menu-item">
              <button
                className="menu-button"
                onClick={() => toggleMenu('structures')}
              >
                <SiInstructure className="menu-icon" /> Structures
                {openMenu === 'structures' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
              </button>
              {openMenu === 'structures' && (
                <div className="submenu">
                  <button className="submenu-link"  onClick={() => toggleMenu('structureList')}>Liste des structures</button>
                  <button className="submenu-link"  onClick={() => toggleMenu('structureForm')}>Ajouter une structure</button>
                </div>
              )}
            </div>
          )} */}

          {/* admins */}
          {/* {userType === 'admin' && (
            <div className="menu-item">
              <button
                className="menu-button"
                onClick={() => toggleMenu('admins')}
              >
                <FaFileAlt className="menu-icon" /> Administrateurs
                {openMenu === 'admins' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
              </button>
              {openMenu === 'admins' && (
                <div className="submenu">
                  <button className="submenu-link" onClick={() => toggleMenu('adminsList')}>Liste des admins</button>
                  <button className="submenu-link"  onClick={() => toggleMenu('adminsForm')}>Ajouter un admin</button>
                </div>
              )}
            </div>
          )} */}

          {/* Services */}
          {userType === 'admin' && (
            <>
                <div className="menu-item">
                    <button
                      className="menu-button"
                      onClick={() => toggleMenu('admins')}
                    >
                      <FaFileAlt className="menu-icon" /> Administrateurs
                      {openMenu === 'admins' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                    </button>
                    {openMenu === 'admins' && (
                      <div className="submenu">
                        <button className="submenu-link" onClick={() => toggleMenu('adminsList')}>Liste des admins</button>
                        <button className="submenu-link"  onClick={() => toggleMenu('adminsForm')}>Ajouter un admin</button>
                      </div>
                    )}
                </div>
                <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('categories')}
                  >
                    <BiCategoryAlt className="menu-icon" /> Catégories
                    {openMenu === 'categories' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'categories' && (
                    <div className="submenu">
                      <button className="submenu-link"  onClick={() => toggleMenu('categorieList')}>Liste des catégories</button>
                      <button className="submenu-link"  onClick={() => toggleMenu('categorieForm')}>Ajouter une catégorie</button>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                <button
                  className="menu-button"
                  onClick={() => toggleMenu('abonnes')}
                >
                  <HiUsers className="menu-icon"/> Abonnées
                  {openMenu === 'abonnes' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                </button>
                {openMenu === 'abonnes' && (
                  <div className="submenu">
                    <button className="submenu-link"  onClick={() => toggleMenu('abonnesList')}>Liste des abonnés</button>
                    <button className="submenu-link"  onClick={() => toggleMenu('abonnesForm')}>Ajouter un abonné</button>
                  </div>
                )}
                </div>
                <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('partenaires')}
                  >
                    <FcDepartment className="menu-icon"/>  Parténaires
                    {openMenu === 'partenaires' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'partenaires' && (
                    <div className="submenu">
                      <button className="submenu-link"  onClick={() => toggleMenu('partenaireList')}>Liste des parténaires</button>
                      <button className="submenu-link"  onClick={() => toggleMenu('partenaireForm')}>Ajouter un partenaire</button>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('structures')}
                  >
                    <SiInstructure className="menu-icon" /> Structures
                    {openMenu === 'structures' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'structures' && (
                    <div className="submenu">
                      <button className="submenu-link"  onClick={() => toggleMenu('structureList')}>Liste des structures</button>
                      <button className="submenu-link"  onClick={() => toggleMenu('structureForm')}>Ajouter une structure</button>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('services')}
                  >
                    <FaServicestack  className="menu-icon"/> Services
                    {openMenu === 'services' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'services' && (
                    <div className="submenu">
                      <button className="submenu-link" onClick={() => toggleMenu('servicesList')}>Liste des services</button>
                      {/* <button className="submenu-link"  onClick={() => toggleMenu('servicesForm')}>Ajouter un service</button> */}
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <button
                    className="menu-button"
                    onClick={() => toggleMenu('cartes')}
                  >
                    <FaFileAlt className="menu-icon" /> Cartes
                    {openMenu === 'cartes' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </button>
                  {openMenu === 'cartes' && (
                    <div className="submenu">
                      <button className="submenu-link" onClick={() => toggleMenu('carteList')}>Liste des cartes</button>
                      <button className="submenu-link"  onClick={() => toggleMenu('carteForm')}>Ajouter une carte</button>
                    </div>
                  )}
                </div>
            </>
          )}

          {/* Authentication */}
          {/* {userType === 'admin' && (
          <div className="menu-item">
            <button
              className="menu-button"
              onClick={() => toggleMenu('auth')}
            >
              <FaSignInAlt className="menu-icon" /> Authentication
              {openMenu === 'auth' ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
            </button>
            {openMenu === 'auth' && (
              <div className="submenu">
                <a href="/signin">Sign In</a>
                <a href="/signup">Sign Up</a>
                <a href="/reset-password">Reset Password</a>
              </div>
            )}
          </div>
          )} */}
        </div>
      </div>
    </>
    

  )
}

export default Sidebar